// extracted by mini-css-extract-plugin
export default {"project-list":"ProjectList_project-list__UwdOk","wrap-item":"ProjectList_wrap-item__dksz5"};